import { Box } from '@mui/material';
import Drawing from '/@/components/drawing';
import Popup from '/@/components/popup';
import { _ } from '/@/locale';
import { toLocaleDateString } from '/@/utils';
import Title from '/@/v3/components/title';

const CritialPeriodModal = ({
    expectedFloweringDate,
    open,
    setOpen,
}: {
    expectedFloweringDate: Date;
    open: boolean;
    setOpen: () => void;
}) => {
    const formattedEFD = toLocaleDateString(expectedFloweringDate, {
        month: 'long',
        day: 'numeric',
    });

    return (
        <Popup visible={open} borderRadius showCloseIcon={true} onClose={() => setOpen(false)}>
            <Box>
                <Box>
                    <Drawing type='no-share-corn' coloredTitle size='sm' />
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Box sx={{ my: 1, display: 'flex', flexDirection: 'column', rowGap: 1 }}>
                        <Title size='lg' color='red' bold>
                            {_(formattedEFD)}
                        </Title>

                        <Title size='md' color='red' bold>
                            {_('Estado crítico +/- 15 días')}
                        </Title>
                    </Box>
                    <Box sx={{ my: 2 }}>
                        <Title size='md'>{_('La fecha de floración es estimada')}</Title>
                    </Box>
                </Box>
            </Box>
        </Popup>
    );
};
export default CritialPeriodModal;
